var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.87533 18.4587H16.1253C17.414 18.4587 18.4587 17.414 18.4587 16.1253V7.37533L10.0003 1.54199L1.54199 7.37533V16.1253C1.54199 17.414 2.58666 18.4587 3.87533 18.4587Z",
    stroke: "#121217",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.37461 14.3742C7.37461 13.0855 8.41928 12.0409 9.70795 12.0409H10.2913C11.5799 12.0409 12.6246 13.0855 12.6246 14.3742V18.4575H7.37461V14.3742Z",
    stroke: "#121217",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.8df44ed154c15cb686e7c576a7b44166.svg";
export { ForwardRef as ReactComponent };